<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisField from 'dashboard/components-next/LaisField.vue';
import LaisToggle from 'dashboard/components-next/LaisToggle.vue';
import {
  DIAS_LABELS,
  PRE_AGENDAMENTO_OPERACOES,
  input,
} from '../utils/minhaLaisOptions';

const form = defineModel({
  type: Object,
  required: true,
});
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <LaisCard title="Horário de atendimento">
    <p class="text-[13px] text-lais-text-muted mb-4">
      Defina quando a Lais responde ativamente seus clientes. Fora desse
      horário, mensagens recebidas ficam aguardando o próximo turno.
    </p>
    <div class="mb-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
      <LaisField label="Início">
        <input v-model="form.horario_inicio" type="time" :class="input" />
      </LaisField>
      <LaisField label="Fim">
        <input v-model="form.horario_fim" type="time" :class="input" />
      </LaisField>
    </div>
    <p class="text-[13px] font-semibold text-lais-text mb-2">Dias da semana</p>
    <div class="flex flex-wrap gap-2">
      <label
        v-for="d in Object.keys(DIAS_LABELS)"
        :key="d"
        class="inline-flex items-center gap-1.5 px-3 h-9 text-[13px] cursor-pointer rounded-lais border transition-colors"
        :class="
          form.dias_semana.includes(d)
            ? 'bg-[#f0e8fa] border-lais-primary text-lais-primary font-semibold'
            : 'bg-white border-[#e5e7eb] text-lais-text-body hover:border-lais-primary'
        "
      >
        <input
          v-model="form.dias_semana"
          type="checkbox"
          :value="d"
          class="hidden"
        />
        {{ DIAS_LABELS[d] }}
      </label>
    </div>
  </LaisCard>

  <LaisCard title="Janela de continuidade">
    <p class="text-[13px] text-lais-text-muted mb-4">
      Se um cliente voltar a falar com a Lais dentro desse período, é
      considerado
      <strong class="text-lais-text">o mesmo atendimento</strong> (não conta
      como novo).
    </p>
    <LaisField
      label="Período de continuidade (dias)"
      helper="Padrão Lais: 30 dias"
    >
      <input
        v-model.number="form.janela_continuidade_dias"
        type="number"
        min="1"
        :class="input"
      />
    </LaisField>
  </LaisCard>

  <LaisCard title="Pré-agendamento de visitas">
    <p class="mb-2 text-[14px] font-semibold text-lais-text">
      Quando a Lais deve oferecer pré-agendamento de visita?
    </p>
    <p class="text-[13px] text-lais-text-muted mb-4">
      Permite que a Lais ofereça horários válidos de visita ao cliente antes da
      confirmação final do corretor. As regras abaixo passam a valer também no
      fluxo público de visita.
    </p>
    <LaisToggle
      v-model="form.funcao_solicitar_visita"
      label="Solicitações via Lais Visita"
      helper="Controla se o fluxo público da Lais pode receber novas solicitações de visita."
      class="mb-4"
    />
    <label class="inline-flex items-center gap-2 mb-4 cursor-pointer">
      <input
        v-model="form.pre_agendamento_ativo"
        type="checkbox"
        class="size-4 accent-lais-primary"
        :disabled="!form.funcao_solicitar_visita"
      />
      <span class="text-[13px] font-semibold text-lais-text">
        Ativar pré-agendamento
      </span>
    </label>
    <p
      v-if="!form.funcao_solicitar_visita"
      class="mb-4 rounded-lais-sm border border-[#e5e7eb] bg-[#faf8fd] px-3 py-2 text-[12px] text-[#6b7280]"
    >
      Com Solicitações via Lais Visita desligado, a Lais não abre novas
      solicitações no fluxo público de visita.
    </p>
    <div
      v-if="form.funcao_solicitar_visita && form.pre_agendamento_ativo"
      class="grid grid-cols-1 gap-4 sm:grid-cols-2"
    >
      <LaisField
        label="Antecedência mínima (horas)"
        helper="Tempo mínimo entre o convite e a visita"
      >
        <input
          v-model.number="form.pre_agendamento_antecedencia_horas"
          type="number"
          min="1"
          :class="input"
        />
      </LaisField>
      <LaisField
        label="Janela máxima (dias)"
        helper="Até quantos dias à frente a Lais pode ofertar"
      >
        <input
          v-model.number="form.pre_agendamento_janela_dias"
          type="number"
          min="1"
          :class="input"
        />
      </LaisField>
      <LaisField
        label="Intervalo entre horários (min)"
        helper="Ex.: 30, 45 ou 60 minutos"
      >
        <input
          v-model.number="form.pre_agendamento_intervalo_minutos"
          type="number"
          min="5"
          step="5"
          :class="input"
        />
      </LaisField>
      <div class="sm:col-span-2">
        <p class="text-[13px] font-semibold text-lais-text mb-2">
          Dias habilitados para visita
        </p>
        <div class="flex flex-wrap gap-2">
          <label
            v-for="d in Object.keys(DIAS_LABELS)"
            :key="`pre-${d}`"
            class="inline-flex items-center gap-1.5 px-3 h-9 text-[13px] cursor-pointer rounded-lais border transition-colors"
            :class="
              form.pre_agendamento_dias_semana.includes(d)
                ? 'bg-[#f0e8fa] border-lais-primary text-lais-primary font-semibold'
                : 'bg-white border-[#e5e7eb] text-lais-text-body hover:border-lais-primary'
            "
          >
            <input
              v-model="form.pre_agendamento_dias_semana"
              type="checkbox"
              :value="d"
              class="hidden"
            />
            {{ DIAS_LABELS[d] }}
          </label>
        </div>
      </div>
      <div class="sm:col-span-2">
        <p class="text-[13px] font-semibold text-lais-text mb-2">
          Operações em que a Lais oferece visita
        </p>
        <div class="flex flex-wrap gap-2">
          <label
            v-for="operation in PRE_AGENDAMENTO_OPERACOES"
            :key="`pre-operation-${operation.value}`"
            class="inline-flex items-center gap-1.5 px-3 h-9 text-[13px] cursor-pointer rounded-lais border transition-colors"
            :class="
              form.pre_agendamento_operacoes.includes(operation.value)
                ? 'bg-[#f0e8fa] border-lais-primary text-lais-primary font-semibold'
                : 'bg-white border-[#e5e7eb] text-lais-text-body hover:border-lais-primary'
            "
          >
            <input
              v-model="form.pre_agendamento_operacoes"
              type="checkbox"
              :value="operation.value"
              class="hidden"
            />
            {{ operation.label }}
          </label>
        </div>
      </div>
      <LaisField
        label="Mensagem enviada ao cliente"
        helper="Usada quando a Lais oferece opções de horário"
        class="sm:col-span-2"
      >
        <textarea
          v-model="form.pre_agendamento_mensagem"
          rows="3"
          :class="input"
        />
      </LaisField>
    </div>
  </LaisCard>

  <LaisCard title="Lembretes de visita">
    <p class="text-[13px] text-lais-text-muted mb-4">
      A Lais envia lembretes automáticos no WhatsApp com a voz da marca antes da
      visita e novamente poucas horas antes do horário.
    </p>
    <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <LaisField
        label="Primeiro lembrete (dias antes)"
        helper="Padrão Lais: 1 dia antes da visita"
      >
        <input
          v-model.number="form.lembrete_visita_antecedencia_dias"
          type="number"
          min="1"
          max="30"
          :class="input"
        />
      </LaisField>
      <LaisField
        label="Lembrete no dia (horas antes)"
        helper="Padrão Lais: 2 horas antes da visita"
      >
        <input
          v-model.number="form.lembrete_visita_dia_horas"
          type="number"
          min="1"
          max="24"
          :class="input"
        />
      </LaisField>
    </div>
  </LaisCard>

  <LaisCard title="Recesso e feriados">
    <p class="text-[13px] text-lais-text-muted mb-4">
      A Lais pode pausar automaticamente em datas específicas e responder com
      uma mensagem personalizada. Reativa sozinha após o recesso.
    </p>
    <label class="inline-flex items-center gap-2 mb-4 cursor-pointer">
      <input
        v-model="form.recesso_ativo"
        type="checkbox"
        class="size-4 accent-lais-primary"
      />
      <span class="text-[13px] font-semibold text-lais-text">
        Ativar pausa em recesso/feriados
      </span>
    </label>
    <div v-if="form.recesso_ativo" class="grid gap-4">
      <LaisField
        label="Datas de recesso"
        helper="Uma data por linha (DD/MM/AAAA) ou intervalo (DD/MM-DD/MM/AAAA)"
      >
        <textarea
          v-model="form.recesso_datas"
          rows="3"
          class="font-mono text-[13px]"
          :class="[input]"
          placeholder="24/12/2026
25/12/2026
30/12-02/01/2027"
        />
      </LaisField>
      <LaisField label="Mensagem de recesso">
        <textarea v-model="form.recesso_mensagem" rows="2" :class="input" />
      </LaisField>
    </div>
  </LaisCard>
</template>
